import type {BulkOperationResponseBody} from '../../types/api/bulkOperations';

type BulkOperationSeverityBarProps = {
  operation: Pick<
    BulkOperationResponseBody,
    'totalCount' | 'doneCount' | 'skippedCount' | 'failedCount'
  >;
};

/** Done/skipped/failed shares of the run; the separator background stands in for pending records. */
export function BulkOperationSeverityBar(props: BulkOperationSeverityBarProps) {
  const operation = props.operation;
  const segments = [
    {count: operation.doneCount, color: 'bg-severity-success'},
    {count: operation.skippedCount, color: 'bg-severity-warning'},
    {count: operation.failedCount, color: 'bg-severity-danger'},
  ] as const;

  return (
    <div aria-hidden className="flex h-1.5 w-full overflow-hidden rounded-full bg-separator">
      {segments
        .filter((segment) => segment.count > 0)
        .map((segment) => (
          <span
            key={segment.color}
            className={`h-full min-w-0.5 border-l! border-solid! border-white first:border-l-0! ${segment.color}`}
            style={{
              width: `${operation.totalCount > 0 ? (segment.count / operation.totalCount) * 100 : 0}%`,
            }}
          />
        ))}
    </div>
  );
}
